export const INVALID_FIELD_CLASS =
  'aria-invalid:border-destructive focus-visible:aria-invalid:border-destructive focus-visible:aria-invalid:ring-destructive/20';
